export default "__VITE_ASSET__B5G2Vdwf__"